
















import { getContracts, getContractType, addContract, getContract, editContract } from '@/api/api';
// @ts-ignore
import { VueEditor } from "vue2-editor";
import router from '@/router';
import { Component, Vue } from 'vue-property-decorator';
@Component({
    components: {
        VueEditor
    },
})
export default class ContractsAdd extends Vue {
    tags: any = [
        {
            label: "Civilité",
            tag: "CIV"
        },
        {
            label: "Nom",
            tag: "NOM"
        },
        {
            label: "Prénom",
            tag: "PRENOM"
        },
        {
            label: "Adresse",
            tag: "ADRESSE"
        },
        {
            label: "Ville",
            tag: "VILLE"
        },
        {
            label: "Code postal",
            tag: "CP"
        },
        {
            label: "Email",
            tag: "EMAIL"
        },
        {
            label: "Entreprise",
            tag: "ENT"
        },
        {
            label: "SIREN",
            tag: "SIREN"
        }

    ]
    newContractContent: string = '';
    type: any = null;
    mode: 'edit' | 'add' = 'add';

    //contract fetched
    contractDb: any = null;

    async created() {
        const el = this.$refs.loading as HTMLElement;
        // @ts-ignore
        this.$vs.loading({
            container: el,
        });

        const contractId = this.$route.params.type;
        this.mode = this.$route.params.mode == 'edit' || this.$route.params.mode == 'add' ? this.$route.params.mode : 'add';
        if (this.mode == 'edit') {
            const { data } = await getContract(contractId);
            console.log(data)
            this.type = data.type;
            this.newContractContent = data.content;
            this.contractDb = data;
        } else {
            const { data } = await getContractType(contractId)
            this.type = data
        }
        // @ts-ignore   
        this.$vs.loading.close(el);
    }

    async addContractAction() {
        const el = this.$refs.loading as HTMLElement;
        // @ts-ignore
        this.$vs.loading({
            container: el,
        });
        const $vs = (this as any).$vs;
        try {
            if (this.mode == 'add') {
                const { data } = await addContract({ content: this.newContractContent }, this.type)
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Succès',
                    text: 'Contrat crée',
                });
            } else if (this.mode == 'edit' && this.contractDb) {
                const { data } = await editContract({ content: this.newContractContent }, this.contractDb.id)
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Succès',
                    text: 'Contrat modifié',
                });
            }
            // @ts-ignore   
            this.$vs.loading.close(el);
            this.$router.push({
                name: 'contrats'
            });
        } catch {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Succès',
                text: 'Une erreur est survenue',
            });
        }
        // @ts-ignore   
        this.$vs.loading.close(el);
    }
}
